import React from 'react';
import InputMask from 'react-input-mask';
import { InputWrapper, FieldContainer, FloatingLabel, MaskedInputStyle, StyledInput, ErrorMessage } from './styles';

export default function DocumentInput({ documentType, name, value, onChange, onBlur, error, disabled }) {
  if (documentType === 'CPF') {
    const hasValue = !!value && value.replace(/[_.\-]/g, '').length > 0;

    return (
      <InputWrapper>
        <FieldContainer $hasError={!!error} $disabled={disabled}>
          {hasValue && <FloatingLabel>CPF</FloatingLabel>}
          <MaskedInputStyle $hasValue={hasValue}>
            <InputMask
              mask="999.999.999-99"
              maskChar={null}
              name={name}
              id={name}
              value={value}
              inputMode="numeric"
              onChange={onChange}
              onBlur={onBlur}
              placeholder={hasValue ? '' : 'Número do CPF'}
              disabled={disabled}
              autoComplete="off"
            />
          </MaskedInputStyle>
        </FieldContainer>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </InputWrapper>
    );
  }

  const hasValue = !!value && value.length > 0;

  return (
    <InputWrapper>
      <FieldContainer $hasError={!!error} $disabled={disabled}>
        {hasValue && <FloatingLabel>Passaporte</FloatingLabel>}
        <StyledInput
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={hasValue ? '' : 'Número do passaporte'}
          maxLength={20}
          $hasValue={hasValue}
          disabled={disabled}
          autoComplete="off"
        />
      </FieldContainer>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </InputWrapper>
  );
}
